var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_35932_36129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3842 0.633229V3.6479H8.49667C8.24648 3.61752 7.99234 3.63863 7.75149 3.70979C7.51065 3.78096 7.28874 3.90052 7.10083 4.06035L7.1025 4.05877C6.83238 4.41877 6.70487 4.85787 6.7425 5.29852V5.29219V7.45027H10.2667L9.8 10.8307H6.7475V19.4963H3.06667V10.8299H0V7.45027H3.06667V4.96048C3.0268 4.35913 3.11732 3.75641 3.33262 3.18964C3.54792 2.62288 3.88342 2.10414 4.31833 1.66556L4.31583 1.66794C4.75973 1.26835 5.28445 0.958591 5.85816 0.757456C6.43187 0.556321 7.04261 0.468002 7.65333 0.497854H7.6425C8.59106 0.48299 9.53955 0.531931 10.4808 0.644313L10.3833 0.634813L10.3842 0.633229Z",
    fill: "#718BAE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_35932_36129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 19,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.019d0ecf.svg";
export { ForwardRef as ReactComponent };